import { getOptionsFromDisplayValue, boolToDisplayValue, boolToDisplayValueHack, noValueDash, getFormSections, convertTypeToReadOnly } from "components/Homeowner/CaseForms/ComparableGrid/Misc";
import {
  drivewayRequired, numOfCarsRequired, carStorage1Required, attachmentType1Required, numOfCars1Required,
  basementExitTypeRequired, belowGradeFinSFRequired, saleDateBBTAdjustmentRequired, saleDateRequired,
  otherBBTAdjustmentRequired, financingTypeRequired, contractDateRequired, salePriceRequired, adjustmentRequired,
  locationType1OtherRequired, locationType2OtherRequired, statusTypeRequired, saleRequired, concessionAmountRequired
} from "components/Homeowner/CaseForms/ComparableGrid/Validate";
import * as sections from "components/Homeowner/CaseForms/ComparableGrid/Sections/Sections";
import { CompGridFormCodes } from "components/Homeowner/CaseForms/ComparableGrid/CompGridFormCodes";

/*
  Type values 
  0: "display"
  1: "none"
  2: "google-autocomplete"
  3: "input"
  4: "dropdown"
  5: "room-count"
  6: "date"
  7: "photo"
*/
export const formSpecificSubjectDefinitions = (subject, settings, states = [], readOnly) => {
  let allSubjectSections = {
    [sections.FEATURE]: {
      "left": { "value": "Feature", "type": "display" },
      "right": { "value": "Subject", "type": "none" },
      "comp": { "muellerid": subject.muellerPropertyId },
    },
    [sections.PRIMARY_PHOTO]: {
      "row":  { "type": "head", "value": "primaryPhotoId" },
      "left": { "value": "Primary Photo", "type": "display" },
      "right": {"value": subject.primaryPhotoId, "type": "photo" }
    },
    [sections.COMPARABLE_TYPE]: {
      "row": { "type": "head", "value": "comparable-type" },
      "left": { "value": "Type", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.ADDRESS]: {
      "row": { "type": "head", "value": "address", "showIcon": true },
      "left": { "value": "Address", "type": "display" },
      "right": { "value": subject.addressLine1, "type": "google-autocomplete", required: true },
    },
    [sections.LATITUDE]: {
      "row": { "type": "body", "value": "address" },
      "left": { "value": "Latitude", "type": "display" },
      "right": { "value": subject.geocodeLatitude, "type": "input", numOnly: true, allowDecimal: true, allowNeg: true },
    },
    [sections.LONGITUDE]: {
      "row": { "type": "body", "value": "address" },
      "left": { "value": "Longitude", "type": "display" },
      "right": { "value": subject.geocodeLongitude, "type": "input", numOnly: true, allowDecimal: true, allowNeg: true },
    },
    [sections.ADDRESS_2]: {
      "row": { "type": "head", "value": "address2" },
      "left": { "value": "Address 2", "type": "display" },
      "right": { "value": subject.addressLine2, "type": "input" },
    },
    [sections.CITY]: {
      "row": { "type": "head", "value": "city" },
      "left": { "value": "City", "type": "display" },
      "right": { "value": subject.addressCity, "type": "input", required: true },
    },
    [sections.STATE]: {
      "row": { "type": "head", "value": "state" },
      "left": { "value": "State", "type": "display" },
      "right": { "value": subject.addressState, "type": "dropdown", "options": [{ label: "", value: "" }].concat(states.map(x => ({ label: x.abbreviation, value: x.abbreviation }))), required: true },
    },
    [sections.ZIP]: {
      "row": { "type": "head", "value": "zip" },
      "left": { "value": "Zip", "type": "display" },
      "right": { "value": subject.addressPostalCode, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
    },
    [sections.PROXIMITY_TO_SUBJECT]: {
      "row": { "type": "head", "value": "proximity" },
      "left": { "value": "Proximity to subject", "type": "display" },
      "right": { "value": { displayValue: "", direction: "", miles: "", postValue: "" }, "type": "none" },
    },
    [sections.SALE_PRICE]: {
      "row": { "type": "head", "value": "salePrice" },
      "left": { "value": "Sale Price", "type": "display" },
      "right": { "value": subject.salePrice, "type": "none" },
    },
    [sections.FINAL_LIST_PRICE]: {
      "row": { "type": "head", "value": "finalListPrice" },
      "left": { "value": "Final List Price", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.SALE_PRICE_GLA]: {
      "row": { "type": "head", "value": "salePriceGla" },
      "left": { "value": "Sale Price / GLA", "type": "display" },
      "right": { "value": subject.salePricePerGrossLivingArea, "type": "display" },
    },
    [sections.DATA_SOURCES_1004P]: {
      "row": { "type": "head", "value": "dataSources" },
      "left": { "value": "Data source(s)", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.DATA_SOURCES_FNMA]: {
      "row": { "type": "head", "value": "dataSourcesFnma" },
      "left": { "value": "Data source(s)", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.VERIFICATION_SOURCES]: {
      "row": { "type": "head", "value": "verificationSources" },
      "left": { "value": "Verification source(s)", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.DAYS_ON_MARKET]: {
      "row": { "type": "head", "value": "daysOnMarket" },
      "left": { "value": "Days On Market", "type": "display" },
      "right": { "value": subject.daysOnMarket.daysOnMarket, "type": "none" },
    },
    [sections.CDOM]: {
      "row": { "type": "head", "value": "cdom" },
      "left": { "value": "CDOM", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.CDOM_WITH_SUBJECT]: {
      "row": { "type": "head", "value": "cdom" },
      "left": { "value": "CDOM", "type": "display" },
      "right": { "value": subject.cdom.cdom, "type": "none", required: true },
    },
    [sections.VALUE_ADJUSTMENTS]: {
      "row": { "type": "head", "value": "value_adjustment" },
      "left": { "value": "Value Adjustments", "type": "display" },
      "right": { "value": "Subject desc", "type": "display" },
      "comp": {},
    },
    [sections.SALE_OR]: {
      "row": { "type": "head", "value": "saleOr" },
      "left": { "value": "Sale or", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.FINANCING_CONCESSIONS]: {
      "row": { "type": "head", "value": "concession", "showIcon": true },
      "left": { "value": "Financing Concessions", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.SALE_1004P]: {
      "row": { "type": "body", "value": "concession" },
      "left": { "value": "Sale", "type": "display" },
      "right": { "value": subject.saleFinancingConcessions.saleType, "type": "none", "options": getOptionsFromDisplayValue(settings.saleTypeChoices) },
    },
    [sections.FINANCING_TYPE]: {
      "row": { "type": "body", "value": "concession" },
      "left": { "value": "Financing Type", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.CONCESSION_AMOUNT]: {
      "row": { "type": "body", "value": "concession" },
      "left": { "value": "Concession Amount", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.CONCESSION_IF_OTHER]: {
      "row": { "type": "body", "value": "concession" },
      "left": { "value": "Concession (if other)", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.DATE_OF_SALE_TIME]: {
      "row": { "type": "head", "value": "dateOfSaleTime", "showIcon": true },
      "left": { "value": "Date of Sale/Time", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.STATUS_TYPE]: {
      "row": { "type": "body", "value": "dateOfSaleTime" },
      "left": { "value": "Status Type", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.SALE_DATE_1004P]: {
      "row": { "type": "body", "value": "dateOfSaleTime" },
      "left": { "value": "Sale Date", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.CONTRACT_DATE]: {
      "row": { "type": "body", "value": "dateOfSaleTime" },
      "left": { "value": "Contract Date", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.SALE_FNMA]: {
      "row": { "type": "head", "value": "sale2" },
      "left": { "value": "Sale", "type": "display" },
      "right": { "value": subject.saleFinancingConcessions.saleType, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.saleTypeChoices) },
    },
    [sections.SALE_DATE_FNMA]: {
      "row": { "type": "head", "value": "saleDate2" },
      "left": { "value": "Sale Date", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.SALE_DATE_BBT]: {
      "row": { "type": "head", "value": "saleDate-bbt" },
      "left": { "value": "Sale Date", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.PROPERTY_TYPE]: {
      "row": { "type": "head", "value": "propertyType" },
      "left": { "value": "Property Type", "type": "display" },
      "right": { "value": subject.propertyType.propertyType, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.propertyTypeChoices) },
    },
    [sections.NUM_OF_UNITS]: {
      "row": { "type": "head", "value": "numOfUnits" },
      "left": { "value": "Number of Units", "type": "display" },
      "right": { "value": subject.numOfUnits.numOfUnits, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
    },
    [sections.YEAR_BUILT]: {
      "row": { "type": "head", "value": "yearBuilt" },
      "left": { "value": "Year Built", "type": "display" },
      "right": { "value": subject.yearBuilt.yearBuilt, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false },
    },
    [sections.LOCATION]: {
      "row": { "type": "head", "value": "location", "showIcon": true },
      "left": { "value": "Location", "type": "display" },
      "right": { "value": subject.location.summary, "type": "display" },
    },
    [sections.LOCATION_RATING]: {
      "row": { "type": "body", "value": "location" },
      "left": { "value": "Location Rating", "type": "display" },
      "right": { "value": subject.location.locationRating, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.locationRatingChoices), required: true },
    },
    [sections.LOCATION_TYPE]: {
      "row": { "type": "body", "value": "location" },
      "left": { "value": "Location Type", "type": "display" },
      "right": { "value": subject.location.locationType, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.locationTypeChoices), required: true },
    },
    [sections.LOCATION_TYPE_1_OTHER]: {
      "row": { "type": "body", "value": "location" },
      "left": { "value": "Location Type 1 Other", "type": "display" },
      "right": { "value": subject.location.locationType1Other, "type": locationType1OtherCellType, required: locationType1OtherRequired },
    },
    [sections.LOCATION_TYPE_2]: {
      "row": { "type": "body", "value": "location" },
      "left": { "value": "Location Type 2", "type": "display" },
      "right": { "value": subject.location.locationType2, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.locationTypeChoices) },
    },
    [sections.LOCATION_TYPE_2_OTHER]: {
      "row": { "type": "body", "value": "location" },
      "left": { "value": "Location Type 2 Other", "type": "display" },
      "right": { "value": subject.location.locationType2Other, "type": locationType2OtherCellType, required: locationType2OtherRequired },
    },
    [sections.LEASEHOLD_FEE_SIMPLE]: {
      "row": { "type": "head", "value": "leasehold-feesimple" },
      "left": { "value": "Leasehold/Fee Simple", "type": "display" },
      "right": { "value": subject.leasholdFeeSimple.leaseholdFeeSimpleType, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.leaseholdFeeSimpleTypeChoices), required: true },
    },
    [sections.SITE]: {
      "row": { "type": "head", "value": "site", "showIcon": true },
      "left": { "value": "Site", "type": "display" },
      "right": { "value": subject.site.summary, "type": "display", required: true },
    },
    [sections.SITE_BBT]: {
      "row": { "type": "head", "value": "site", "showIcon": true },
      "left": { "value": "Site", "type": "display" },
      "right": { "value": subject.site.summary, "type": "display", required: true },
    },
    [sections.SQUARE_FEET]: {
      "row": { "type": "body", "value": "site" },
      "left": { "value": "Square Feet", "type": "display" },
      "right": { "value": subject.site.landAreaSquareFeet, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false },
    },
    [sections.ACRES]: {
      "row": { "type": "body", "value": "site" },
      "left": { "value": "Acres", "type": "display" },
      "right": { "value": subject.site.landAreaAcres, "type": "input", numOnly: true, allowDecimal: true, allowNeg: false },
    },
    [sections.ADJUSTMENTS_SITE]: {
      "row": { "type": "body", "value": "site", "adjustment": true },
      "left": { "value": "", "type": "display" },
      "right": { "value": "Apply", "type": "display" },
    },
    [sections.VIEW]: {
      "row": { "type": "head", "value": "view", "showIcon": true },
      "left": { "value": "View", "type": "display" },
      "right": { "value": subject.view.summary, "type": "display" },
    },
    [sections.VIEW_RATING]: {
      "row": { "type": "body", "value": "view" },
      "left": { "value": "View Rating", "type": "display" },
      "right": { "value": subject.view.viewRating, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.viewRatingChoices), required: true },
    },
    [sections.VIEW_TYPE]: {
      "row": { "type": "body", "value": "view" },
      "left": { "value": "View Type", "type": "display" },
      "right": { "value": subject.view.viewType, "type": "dropdown", "options": [...getOptionsFromDisplayValue(settings.viewTypeChoices), "Other"], required: true },
    },
    [sections.VIEW_TYPE_2]: {
      "row": { "type": "body", "value": "view" },
      "left": { "value": "View Type 2", "type": "display" },
      "right": { "value": subject.view.viewType2, "type": "dropdown", "options": [...getOptionsFromDisplayValue(settings.viewTypeChoices), "Other"] },
    },
    [sections.DESIGN_STYLE]: {
      "row": { "type": "head", "value": "design", "showIcon": true },
      "left": { "value": "Design (Style)", "type": "display" },
      "right": { "value": subject.design.summary, "type": "display", required: true },
    },
    [sections.ATT_DET]: {
      "row": { "type": "body", "value": "design" },
      "left": { "value": "Att/Det", "type": "display" },
      "right": { "value": subject.design.attachedDetached, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.attachedDetachedChoices), required: true },
    },
    [sections.STORIES]: {
      "row": { "type": "body", "value": "design" },
      "left": { "value": "Stories", "type": "display" },
      "right": { "value": subject.design.stories, "type": "input", numOnly: true, allowDecimal: true, allowNeg: false, required: true },
    },
    [sections.DESIGN]: {
      "row": { "type": "body", "value": "design" },
      "left": { "value": "Design", "type": "display" },
      "right": { "value": subject.design.designStyle, "type": "input", "options": getOptionsFromDisplayValue(settings.designChoices), required: true },
    },
    [sections.ACTUAL_AGE]: {
      "row": { "type": "head", "value": "age", "showIcon": true },
      "left": { "value": settings.compGridFormCode === CompGridFormCodes.REOMIT_APPRAISAL_COMPARABLES ? "Year Built" : "Actual Age", "type": "display" },
      "right": { "value": subject.actualAge.ageYears, "type": "input", numOnly: true, allowNeg: false, allowDecimal: false, required: true },
    },
    [sections.ESTIMATED]: {
      "row": { "type": "head", "value": "age-estimated" },
      "left": { "value": "Is Age Estimated?", "type": "display" },
      "right": { "value": boolToDisplayValue(subject.actualAge.ageEstimated), "type": "dropdown", "options": getOptionsFromDisplayValue([{ displayValue: "Yes", storedValue: "yes" }, { displayValue: "No", storedValue: "no" }]), required: true },
    },
    [sections.ADJUSTMENTS_AGE]: {
      "row": { "type": "body", "value": "age", "adjustment": true },
      "left": { "value": "", "type": "display" },
      "right": { "value": "Apply", "type": "display" },
    },
    [sections.QUALITY]: {
      "row": { "type": "head", "value": "quality" },
      "left": { "value": "Quality", "type": "display" },
      "right": { "value": subject.quality.qualityRating, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.qualityChoices), required: true },
    },
    [sections.QUALITY_BBT]: {
      "row": { "type": "head", "value": "quality-bbt" },
      "left": { "value": "Quality", "type": "display" },
      "right": { "value": subject.quality.qualityRating, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.qualityChoices), required: true },
    },
    [sections.CONDITION]: {
      "row": { "type": "head", "value": "condition" },
      "left": { "value": "Condition", "type": "display" },
      "right": { "value": subject.condition.conditionRating, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.conditionChoices), required: true },
    },
    [sections.CONDITION_BBT]: {
      "row": { "type": "head", "value": "condition-bbt" },
      "left": { "value": "Condition", "type": "display" },
      "right": { "value": subject.condition.conditionRating, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.conditionChoices), required: true },
    },
    [sections.NUM_OF_FLOORS]: {
      "row": { "type": "head", "value": "numOfFloors" },
      "left": { "value": "# of Floors", "type": "display" },
      "right": { "value": subject.numOfFloors.numOfFloors, "type": "input", numOnly: true, allowNeg: false, allowDecimal: false, required: true },
    },
    [sections.FLOOR_LOCATION]: {
      "row": { "type": "head", "value": "floorLocation" },
      "left": { "value": "Floor Location", "type": "display" },
      "right": { "value": subject.floorLocation.floorLocation, "type": "input", required: true },
    },
    [sections.MONTHLY_RENTAL_RATE]: {
      "row": { "type": "head", "value": "monthlyRentalRate" },
      "left": { "value": "Rent", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.ABOVE_GRADE]: {
      "row": { "type": "head", "value": "above-grade", "showIcon": false },
      "left": { "value": "Above Grade", "type": "display" },
      "right": { "value": "", "type": "room-count", "options": ["Total", "Bed", "Bath"] },
    },
    [sections.ABOVE_GRADE_BBT]: {
      "row": { "type": "head", "value": "above-grade-bbt", "showIcon": false },
      "left": { "value": "Above Grade", "type": "display" },
      "right": { "value": "", "type": "room-count", "options": ["Total", "Bed", "Bath"] },
    },
    [sections.ABOVE_GRADE_ROOM_COUNT]: {
      "row": { "type": "head", "value": "above-grade", "showIcon": true },
      "left": { "value": "Room Count", "type": "display" },
      "right": {
        "value": "", "type": "room-count", "options": [noValueDash(subject.aboveGradeRooms.totalRoomCount), noValueDash(subject.aboveGradeRooms.bedroomCount),
        `${noValueDash(subject.aboveGradeRooms.fullBathroomCount)}.${noValueDash(subject.aboveGradeRooms.halfBathroomCount)}`]
      },
    },
    [sections.ABOVE_GRADE_ROOM_COUNT_BBT]: {
      "row": { "type": "head", "value": "above-grade-bbt", "showIcon": true },
      "left": { "value": "Room Count", "type": "display" },
      "right": {
        "value": "", "type": "room-count", "options": [noValueDash(subject.aboveGradeRooms.totalRoomCount), noValueDash(subject.aboveGradeRooms.bedroomCount),
        `${noValueDash(subject.aboveGradeRooms.fullBathroomCount)}.${noValueDash(subject.aboveGradeRooms.halfBathroomCount)}`]
      },
    },
    [sections.TOTAL]: {
      "row": { "type": "body", "value": "above-grade" },
      "left": { "value": "Total", "type": "display" },
      "right": { "value": subject.aboveGradeRooms.totalRoomCount, "type": "input", required: true },
    },
    [sections.TOTAL_BBT]: {
      "row": { "type": "body", "value": "above-grade-bbt" },
      "left": { "value": "Total", "type": "display" },
      "right": { "value": subject.aboveGradeRooms.totalRoomCount, "type": "input", required: true },
    },
    [sections.BEDROOMS]: {
      "row": { "type": "body", "value": "above-grade" },
      "left": { "value": "Bedrooms", "type": "display" },
      "right": { "value": subject.aboveGradeRooms.bedroomCount, "type": "input", required: true },
    },
    [sections.BEDROOMS_BBT]: {
      "row": { "type": "body", "value": "above-grade-bbt" },
      "left": { "value": "Bedrooms", "type": "display" },
      "right": { "value": subject.aboveGradeRooms.bedroomCount, "type": "input", required: true },
    },
    [sections.BATHROOMS]: {
      "row": { "type": "body", "value": "above-grade" },
      "left": { "value": "Bathrooms", "type": "display" },
      "right": { "value": subject.aboveGradeRooms.fullBathroomCount, "type": "input", required: true },
    },
    [sections.BATHROOMS_BBT]: {
      "row": { "type": "body", "value": "above-grade-bbt" },
      "left": { "value": "Bathrooms", "type": "display" },
      "right": { "value": subject.aboveGradeRooms.fullBathroomCount, "type": "input", required: true },
    },
    [sections.HALF_BATHROOMS]: {
      "row": { "type": "body", "value": "above-grade" },
      "left": { "value": "Half bathrooms", "type": "display" },
      "right": { "value": subject.aboveGradeRooms.halfBathroomCount, "type": "input", required: true },
    },
    [sections.HALF_BATHROOMS_BBT]: {
      "row": { "type": "body", "value": "above-grade-bbt" },
      "left": { "value": "Half bathrooms", "type": "display" },
      "right": { "value": subject.aboveGradeRooms.halfBathroomCount, "type": "input", required: true },
    },
    [sections.ADJUSTMENTS_ROOM_COUNT]: {
      "row": { "type": "body", "value": "above-grade", "adjustment": true },
      "left": { "value": "", "type": "display" },
      "right": { "value": "Apply", "type": "display" },
    },
    [sections.GLA]: {
      "row": { "type": "head", "value": "gla", "showIcon": true },
      "left": { "value": "GLA", "type": "display" },
      "right": { "value": subject.grossLivingArea.grossLivingArea, "type": "input", required: true },
    },
    [sections.GLA_BBT]: {
      "row": { "type": "head", "value": "gla-bbt" },
      "left": { "value": "GLA", "type": "display" },
      "right": { "value": subject.grossLivingArea.grossLivingArea, "type": "input", required: true },
    },
    [sections.ADJUSTMENTS_GLA]: {
      "row": { "type": "body", "value": "gla", "adjustment": true },
      "left": { "value": "", "type": "display" },
      "right": { "value": "Apply", "type": "display" },
    },
    [sections.BASEMENT_FINISHED]: {
      "row": { "type": "head", "value": "basement-finished", "showIcon": true },
      "left": { "value": "Basement & Finished", "type": "display" },
      "right": { "value": subject.belowGrade.summary, "type": "display" },
    },
    [sections.BASEMENT_FINISHED_BBT]: {
      "row": { "type": "head", "value": "basement-finished-bbt", "showIcon": true },
      "left": { "value": "Basement & Finished", "type": "display" },
      "right": { "value": subject.belowGrade.summary, "type": "display" },
    },
    [sections.BELOW_GRADE_TOT_SF]: {
      "row": { "type": "body", "value": "basement-finished" },
      "left": { "value": "Below Grade Tot SF", "type": "display" },
      "right": { "value": subject.belowGrade.totalSquareFeet, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
    },
    [sections.BELOW_GRADE_TOT_SF_BBT]: {
      "row": { "type": "body", "value": "basement-finished-bbt" },
      "left": { "value": "Below Grade Tot SF", "type": "display" },
      "right": { "value": subject.belowGrade.totalSquareFeet, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
    },
    [sections.BELOW_GRADE_FIN_SF]: {
      "row": { "type": "body", "value": "basement-finished" },
      "left": { "value": "Below Grade Fin SF", "type": "display" },
      "right": { "value": subject.belowGrade.finishedSquareFeet, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: belowGradeFinSFRequired },
    },
    [sections.BELOW_GRADE_FIN_SF_BBT]: {
      "row": { "type": "body", "value": "basement-finished-bbt" },
      "left": { "value": "Below Grade Fin SF", "type": "display" },
      "right": { "value": subject.belowGrade.finishedSquareFeet, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: belowGradeFinSFRequired },
    },
    [sections.BASEMENT_EXIT_TYPE]: {
      "row": { "type": "body", "value": "basement-finished" },
      "left": { "value": "Basement Exit Type", "type": "display" },
      "right": { "value": subject.belowGrade.basementExitType, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.basementExitTypeChoices), required: basementExitTypeRequired },
    },
    [sections.BASEMENT_EXIT_TYPE_BBT]: {
      "row": { "type": "body", "value": "basement-finished-bbt" },
      "left": { "value": "Basement Exit Type", "type": "display" },
      "right": { "value": subject.belowGrade.basementExitType, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.basementExitTypeChoices), required: basementExitTypeRequired },
    },
    [sections.BELOW_GRADE_ROOM_COUNT_FNMA]: {
      "row": { "type": "head", "value": "belowGradeRoomCount" },
      "left": { "value": "Below Grade - Room Count", "type": "display" },
      "right": { "value": subject.belowGradeRoomCount.belowGradeRoomCount, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
    },
    [sections.HEATING_FNMA]: {
      "row": { "type": "head", "value": "heating2" },
      "left": { "value": "Heating", "type": "display" },
      "right": { "value": subject.heatingCooling.heatingType, "type": "input", required: true },
    },
    [sections.COOLING_FNMA]: {
      "row": { "type": "head", "value": "cooling2" },
      "left": { "value": "Cooling", "type": "display" },
      "right": { "value": subject.heatingCooling.coolingType, "type": "input", required: true },
    },
    [sections.BELOW_GRADE]: {
      "row": { "type": "head", "value": "below-grade-rooms", "showIcon": false },
      "left": { "value": "Below Grade", "type": "display" },
      "right": { "value": "", "type": "room-count", "options": ["Rec", "Bed", "Bath", "Othr"] },
    },
    [sections.BELOW_GRADE_ROOM_COUNT]: {
      "row": { "type": "head", "value": "below-grade-rooms", "showIcon": true },
      "left": { "value": "Room Count", "type": "display" },
      "right": {
        "value": "", "type": "room-count", "options": [noValueDash(subject.belowGradeRooms.recRoomCount), noValueDash(subject.belowGradeRooms.bedroomCount),
        `${noValueDash(subject.belowGradeRooms.fullBathroomCount)}.${noValueDash(subject.belowGradeRooms.halfBathroomCount)}`, noValueDash(subject.belowGradeRooms.otherRoomCount)]
      },
    },
    [sections.REC]: {
      "row": { "type": "body", "value": "below-grade-rooms" },
      "left": { "value": "Rec", "type": "display" },
      "right": { "value": subject.belowGradeRooms.recRoomCount, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
    },
    [sections.BED]: {
      "row": { "type": "body", "value": "below-grade-rooms" },
      "left": { "value": "Bed", "type": "display" },
      "right": { "value": subject.belowGradeRooms.bedroomCount, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
    },
    [sections.FULL_BATH]: {
      "row": { "type": "body", "value": "below-grade-rooms" },
      "left": { "value": "Full Bath", "type": "display" },
      "right": { "value": subject.belowGradeRooms.fullBathroomCount, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
    },
    [sections.HALF_BATH]: {
      "row": { "type": "body", "value": "below-grade-rooms" },
      "left": { "value": "Half Bath", "type": "display" },
      "right": { "value": subject.belowGradeRooms.halfBathroomCount, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
    },
    [sections.OTHER]: {
      "row": { "type": "body", "value": "below-grade-rooms" },
      "left": { "value": "Other", "type": "display" },
      "right": { "value": subject.belowGradeRooms.otherRoomCount, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
    },
    [sections.HEATING_COOLING]: {
      "row": { "type": "head", "value": "heating-cooling", "showIcon": true },
      "left": { "value": "Heating/Cooling", "type": "display" },
      "right": { "value": subject.heatingCooling.summary, "type": "display" },
    },
    [sections.HEATING_1004P]: {
      "row": { "type": "body", "value": "heating-cooling" },
      "left": { "value": "Heating", "type": "display" },
      "right": { "value": subject.heatingCooling.heatingType, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.heatingTypeChoices), required: true },
    },
    [sections.COOLING_1004P]: {
      "row": { "type": "body", "value": "heating-cooling" },
      "left": { "value": "Cooling", "type": "display" },
      "right": { "value": subject.heatingCooling.coolingType, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.coolingTypeChoices), required: true },
    },
    [sections.GARAGE_CARPORT]: {
      "row": { "type": "head", "value": "garage-carport", "showIcon": true },
      "left": { "value": "Garage/Carport", "type": "display" },
      "right": { "value": subject.garageCarport.summary, "type": "display", required: true },
    },
    [sections.GARAGE_CARPORT_BBT]: {
      "row": { "type": "head", "value": "garage-carport-bbt", "showIcon": true },
      "left": { "value": "Garage/Carport", "type": "display" },
      "right": { "value": subject.garageCarport.summary, "type": "display", required: true },
    },
    [sections.GARAGE_CARPORT_MVALUE]: {
      "row": { "type": "head", "value": "garage-carport-mvalue", "showIcon": true },
      "left": { "value": "Garage/Carport", "type": "display" },
      "right": { "value": subject.garageCarport.summary, "type": "display", required: true },
    },
    [sections.DRIVEWAY]: {
      "row": { "type": "body", "value": "garage-carport" },
      "left": { "value": "Driveway", "type": "display" },
      "right": { "value": subject.garageCarport.drivewayType, "type": "display" },
    },
    [sections.DRIVEWAY_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt" },
      "left": { "value": "Driveway", "type": "display" },
      "right": { "value": subject.garageCarport.drivewayType, "type": "display" },
    },
    [sections.DRIVEWAY_ENABLED]: {
      "row": { "type": "body", "value": "garage-carport-mvalue" },
      "left": { "value": "Driveway", "type": "display" },
      "right": { "value": subject.garageCarport.drivewayType, "type": "dropdown", "options": getOptionsFromDisplayValue([{ displayValue: "Yes", storedValue: "yes" }, { displayValue: "No", storedValue: "no" }]), required: drivewayRequired },
    },
    [sections.NUM_OF_CARS]: {
      "row": { "type": "body", "value": "garage-carport" },
      "left": { "value": "# of Cars", "type": "display" },
      "right": { "value": subject.garageCarport.drivewayCarCapacity, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: numOfCarsRequired },
    },
    [sections.NUM_OF_CARS_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt" },
      "left": { "value": "# of Cars", "type": "display" },
      "right": { "value": subject.garageCarport.drivewayCarCapacity, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: numOfCarsRequired },
    },
    [sections.NUM_OF_CARS_MVALUE]: {
      "row": { "type": "body", "value": "garage-carport-mvalue" },
      "left": { "value": "# of Cars", "type": "display" },
      "right": { "value": subject.garageCarport.drivewayCarCapacity, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: numOfCarsRequired },
    },
    [sections.CAR_STORAGE_1]: {
      "row": { "type": "body", "value": "garage-carport" },
      "left": { "value": "Car Storage 1", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageType1, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.carStorageChoices), required: carStorage1Required },
    },
    [sections.CAR_STORAGE_1_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt" },
      "left": { "value": "Car Storage 1", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageType1, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.carStorageChoices), required: carStorage1Required },
    },
    [sections.CAR_STORAGE_1_MVALUE]: {
      "row": { "type": "body", "value": "garage-carport-mvalue" },
      "left": { "value": "Car Storage 1", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageType1, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.carStorageChoices), required: carStorage1Required },
    },
    [sections.ATTACHMENT_TYPE_1]: {
      "row": { "type": "body", "value": "garage-carport" },
      "left": { "value": "Attachment Type 1", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageAttachmentType1, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.carStorageAttachmentTypeChoices), required: attachmentType1Required },
    },
    [sections.ATTACHMENT_TYPE_1_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt" },
      "left": { "value": "Attachment Type 1", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageAttachmentType1, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.carStorageAttachmentTypeChoices), required: attachmentType1Required },
    },
    [sections.ATTACHMENT_TYPE_1_MVALUE]: {
      "row": { "type": "body", "value": "garage-carport-mvalue" },
      "left": { "value": "Attachment Type 1", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageAttachmentType1, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.carStorageAttachmentTypeChoices), required: attachmentType1Required },
    },
    [sections.NUM_OF_CARS_1]: {
      "row": { "type": "body", "value": "garage-carport" },
      "left": { "value": "# of Cars 1", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageCarCapacity1, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: numOfCars1Required },
    },
    [sections.NUM_OF_CARS_1_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt" },
      "left": { "value": "# of Cars 1", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageCarCapacity1, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: numOfCars1Required },
    },
    [sections.NUM_OF_CARS_1_MVALUE]: {
      "row": { "type": "body", "value": "garage-carport-mvalue" },
      "left": { "value": "# of Cars 1", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageCarCapacity1, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: numOfCars1Required },
    },
    [sections.CAR_STORAGE_2]: {
      "row": { "type": "body", "value": "garage-carport", tabs: 2 },
      "left": { "value": "Car Storage 2", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageType2, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.carStorageChoices) },
    },
    [sections.CAR_STORAGE_2_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt", tabs: 2 },
      "left": { "value": "Car Storage 2", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageType2, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.carStorageChoices) },
    },
    [sections.CAR_STORAGE_2_MVALUE]: {
      "row": { "type": "body", "value": "garage-carport-mvalue", tabs: 2 },
      "left": { "value": "Car Storage 2", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageType2, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.carStorageChoices) },
    },
    [sections.ATTACHMENT_TYPE_2]: {
      "row": { "type": "body", "value": "garage-carport", tabs: 2 },
      "left": { "value": "Attachment Type 2", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageAttachmentType2, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.carStorageAttachmentTypeChoices) },
    },
    [sections.ATTACHMENT_TYPE_2_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt", tabs: 2 },
      "left": { "value": "Attachment Type 2", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageAttachmentType2, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.carStorageAttachmentTypeChoices) },
    },
    [sections.ATTACHMENT_TYPE_2_MVALUE]: {
      "row": { "type": "body", "value": "garage-carport-mvalue", tabs: 2 },
      "left": { "value": "Attachment Type 2", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageAttachmentType2, "type": "dropdown", "options": getOptionsFromDisplayValue(settings.carStorageAttachmentTypeChoices) },
    },
    [sections.NUM_OF_CARS_2]: {
      "row": { "type": "body", "value": "garage-carport", tabs: 2 },
      "left": { "value": "# of Cars 2", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageCarCapacity2, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false },
    },
    [sections.NUM_OF_CARS_2_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt", tabs: 2 },
      "left": { "value": "# of Cars 2", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageCarCapacity2, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false },
    },
    [sections.NUM_OF_CARS_2_MVALUE]: {
      "row": { "type": "body", "value": "garage-carport-mvalue", tabs: 2 },
      "left": { "value": "# of Cars 2", "type": "display" },
      "right": { "value": subject.garageCarport.carStorageCarCapacity2, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false },
    },
    [sections.ENERGY_EFFICIENT_ITEMS]: {
      "row": { "type": "head", "value": "energy-efficient-items" },
      "left": { "value": "Energy Eff Items", "type": "display" },
      "right": { "value": subject.energyEfficientItems.energyEfficientItems, "type": "input", required: true },
    },
    [sections.FUNCTIONAL_UTILITY]: {
      "row": { "type": "head", "value": "functional-utility" },
      "left": { "value": "Functional Utility", "type": "display" },
      "right": { "value": subject.functionalUtility.functionalUtility, "type": "input", required: true },
    },
    [sections.PORCH_PATIO_DECK]: {
      "row": { "type": "head", "value": "porch-patio-deck", showIcon: true },
      "left": { "value": "Porch/Patio/Deck", "type": "display" },
      "right": { "value": subject.porchPatioDeck.porchPatioDeckType, "type": "display", required: true },
    },
    [sections.PORCH]: {
      "row": { "type": "body", "value": "porch-patio-deck" },
      "left": { "value": "Porch", "type": "display" },
      "right": { "value": subject.porchPatioDeck.porchType, "type": "input", required: true },
    },
    [sections.PATIO_DECK]: {
      "row": { "type": "body", "value": "porch-patio-deck" },
      "left": { "value": "Patio/Deck", "type": "display" },
      "right": { "value": subject.porchPatioDeck.patioDeckType, "type": "input", required: true },
    },
    [sections.POOL]: {
      "row": { "type": "head", "value": "pool" },
      "left": { "value": "Pool", "type": "display" },
      "right": { "value": boolToDisplayValueHack(subject.pool.pool), "type": "dropdown", "options": getOptionsFromDisplayValue(settings.poolTypeChoices), required: true },
    },
    [sections.OTHER_NAME_1]: {
      "row": { "type": "head", "value": "other-name-1" },
      "left": { "value": "Other Name 1", "type": "display" },
      "right": { "value": subject.other.otherType, "type": "input" },
    },
    [sections.OTHER_1_DESC]: {
      "row": { "type": "head", "value": "other-1-desc" },
      "left": { "value": "Other 1 desc.", "type": "display" },
      "right": { "value": subject.other.otherDesc, "type": "input" },
    },
    [sections.OTHER_NAME_2]: {
      "row": { "type": "head", "value": "other-name-2" },
      "left": { "value": "Other Name 2", "type": "display" },
      "right": { "value": subject.other.other2Type, "type": "input" },
    },
    [sections.OTHER_2_DESC]: {
      "row": { "type": "head", "value": "other-2-desc" },
      "left": { "value": "Other 2 desc.", "type": "display" },
      "right": { "value": subject.other.other2Desc, "type": "input" },
    },
    [sections.OTHER_NAME_3]: {
      "row": { "type": "head", "value": "other-name-3" },
      "left": { "value": "Other Name 3", "type": "display" },
      "right": { "value": subject.other.other3Type, "type": "input" },
    },
    [sections.OTHER_3_DESC]: {
      "row": { "type": "head", "value": "other-3-desc" },
      "left": { "value": "Other 3 desc.", "type": "display" },
      "right": { "value": subject.other.other3Desc, "type": "input" },
    },
    [sections.NET_ADJ]: {
      "row": { "type": "head", "value": "net-adj" },
      "left": { "value": "Net Adj.", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.ADJ_NET_PRICE]: {
      "row": { "type": "head", "value": "adj-net-price" },
      "left": { "value": "Adj. Net Price", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.ADJ_GROSS_PRICE]: {
      "row": { "type": "head", "value": "adj-gross-price" },
      "left": { "value": "Adj. Gross Price", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.ACTUAL_AGE_MVALUE]: {
      "row": { "type": "head", "value": "actual-age-mvalue" },
      "left": { "value": "Actual Age", "type": "display" },
      "right": { "value": subject.actualAge.ageYears, "type": "input", required: true },
    },
    [sections.ACTUAL_AGE_BBT]: {
      "row": { "type": "head", "value": "actual-age-bbt" },
      "left": { "value": "Actual Age", "type": "display" },
      "right": { "value": subject.actualAge.ageYears, "type": "input", required: true },
    },
    [sections.OTHER_MVALUE]: {
      "row": { "type": "head", "value": "other-mvalue" },
      "left": { "value": "Other", "type": "display" },
      "right": { "value": subject.other.otherType, "type": "input" },
    },
    [sections.OTHER_BBT]: {
      "row": { "type": "head", "value": "other-bbt" },
      "left": { "value": "Other", "type": "display" },
      "right": { "value": subject.other.otherType, "type": "input" },
    },
    [sections.COMPARISON_TO_SUBJECT]: {
      "row": { "type": "head", "value": "comparison-to-subject" },
      "left": { "value": "Comparison to Subject", "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.COMMENTS]: {
      "row": { "type": "head", "value": "comments" },
      "left": { "value": "Comments", "type": "display" },
      "right": { "value": subject.adjustmentComments, "type": "textarea" },
    },
  };
  const filtered = getFormSections(settings.compGridFormCode)
    .reduce((acc, key) => {
      let sec = allSubjectSections[key];
      if (readOnly) {
        // dont add adjustment calc section
        if (sec && sec.row && sec.row.adjustment) {
          return acc;
        }
        sec = convertTypeToReadOnly(sec);
      }
      acc[key] = sec;
      return acc;
    }, {});
  return filtered;
};

export const formSpecificComparableSections = (item, gridData, isNew = false, states = [], readOnly) => {
  const { settings } = gridData;
  let { pool, belowGradeRoomCount, monthlyRentalRate, floorLocation, numOfFloors, numOfUnits, propertyType, cdom, netAdjustmentsPercentage, netAdjustmentsAmount, grossAdjustmentsPercentage, grossAdjustmentsAmount, aboveGradeRooms, other, porchPatioDeck, saleFinancingConcessions, dateOfSaleTime, location, site, view, design, actualAge, condition, grossLivingArea, belowGrade, heatingCooling, garageCarport, leasholdFeeSimple, quality, energyEfficientItems, functionalUtility, daysOnMarket, belowGradeRooms, yearBuilt } = item || {};
  let allComparableSections = {
    [sections.FEATURE]: {
      "left": { "value": "Comparable", "type": "display" },
      "right": { "value": "", "type": "display" },
      "comp": { "muellerid": isNew ? null : item.muellerPropertyId, imageURLs: isNew ? null : item.imageURLs },
    },
    [sections.PRIMARY_PHOTO]: {
      "row":  { "type": "head", "value": "primaryPhotoId" },
      "left": { "value": isNew ? null : item.primaryPhotoId, "type": "photo" },
      "right": {"value": "", "type": "none" }
    },
    [sections.COMPARABLE_TYPE]: {
      "row": { "type": "head", "value": "comparable-type" },
      "left": { "value": isNew ? "" : item.comparableType, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.comparableTypeChoices), required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.ADDRESS]: {
      "row": { "type": "head", "value": "address" },
      "left": { "value": isNew ? "" : item.addressLine1, "type": "google-autocomplete", required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.LATITUDE]: {
      "row": { "type": "body", "value": "address" },
      "left": { "value": isNew ? "" : item.geocodeLatitude, "type": "input", numOnly: true, allowDecimal: true, allowNeg: true, required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.LONGITUDE]: {
      "row": { "type": "body", "value": "address" },
      "left": { "value": isNew ? "" : item.geocodeLongitude, "type": "input", numOnly: true, allowDecimal: true, allowNeg: true, required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.ADDRESS_2]: {
      "row": { "type": "head", "value": "address2" },
      "left": { "value": isNew ? "" : item.addressLine2, "type": "input" },
      "right": { "value": "", "type": "none" },
    },
    [sections.CITY]: {
      "row": { "type": "head", "value": "city" },
      "left": { "value": isNew ? "" : item.addressCity, "type": "input", required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.STATE]: {
      "row": { "type": "head", "value": "state" },
      "left": { "value": isNew ? "" : item.addressState, "type": "dropdown", "options": [{ label: "", value: "" }].concat(states.map(x => ({ label: x.abbreviation, value: x.abbreviation }))), required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.ZIP]: {
      "row": { "type": "head", "value": "zip" },
      "left": { "value": isNew ? "" : item.addressPostalCode, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.PROXIMITY_TO_SUBJECT]: {
      "row": { "type": "head", "value": "proximity" },
      "left": { "value": { displayValue: "", direction: "", miles: isNew ? "" : item.proximityToSubjectMiles, postValue: "" }, "type": "display", required: true },  // value calculated in componentDidUpdate
      "right": { "value": "", "type": "none" },
    },
    [sections.SALE_PRICE]: {
      "row": { "type": "head", "value": "salePrice" },
      "left": { "value": isNew ? "" : item.salePrice, "type": "input", required: salePriceRequired },
      "right": { "value": "", "type": "none" },
    },
    [sections.FINAL_LIST_PRICE]: {
      "row": { "type": "head", "value": "finalListPrice" },
      "left": { "value": isNew ? "" : item.finalListPrice, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false },
      "right": { "value": "", "type": "none" },
    },
    [sections.SALE_PRICE_GLA]: {
      "row": { "type": "head", "value": "salePriceGla" },
      "left": { "value": isNew ? "" : item.salePricePerGrossLivingArea, "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.DATA_SOURCES_1004P]: {
      "row": { "type": "head", "value": "dataSources" },
      "left": { "value": isNew ? "" : item.dataSources, "type": "input", required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.DATA_SOURCES_FNMA]: {
      "row": { "type": "head", "value": "dataSourcesFnma" },
      "left": { "value": isNew ? "" : item.dataSources, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.dataSourceChoices), required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.VERIFICATION_SOURCES]: {
      "row": { "type": "head", "value": "verificationSources" },
      "left": { "value": isNew ? "" : item.verificationSources, "type": "input", required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.DAYS_ON_MARKET]: {
      "row": { "type": "head", "value": "daysOnMarket" },
      "left": { "value": isNew ? "" : daysOnMarket.daysOnMarket, "type": "input", required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.CDOM]: {
      "row": { "type": "head", "value": "cdom" },
      "left": { "value": isNew ? "" : cdom.cdom, "type": "input", required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.CDOM_WITH_SUBJECT]: {
      "row": { "type": "head", "value": "cdom" },
      "left": { "value": isNew ? "" : cdom.cdom, "type": "input", required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.VALUE_ADJUSTMENTS]: {
      "row": { "type": "head", "value": "value_adjustment" },
      "left": { "value": "Comp desc", "type": "display" },
      "right": { "value": "Adj", "type": "display" },
      "comp": {},
    },
    [sections.SALE_OR]: {
      "row": { "type": "head", "value": "saleOr" },
      "left": { "value": isNew ? "" : saleFinancingConcessions.summarySale, "type": "display" },
      "right": { "value": isNew ? "" : saleFinancingConcessions.concessionAdjustmentAmount, "type": saleOrAdjustmentCellType },
    },
    [sections.FINANCING_CONCESSIONS]: {
      "row": { "type": "head", "value": "concession" },
      "left": { "value": isNew ? "" : saleFinancingConcessions.summaryFinancing, "type": financingConcessionsCellType },
      "right": { "value": "", "type": "none" },
    },
    [sections.SALE_1004P]: {
      "row": { "type": "body", "value": "concession" },
      "left": { "value": isNew ? "" : saleFinancingConcessions.saleType, "type": saleCellType, "options": getOptionsFromDisplayValue(gridData.settings.saleTypeChoices), required: saleRequired },
      "right": { "value": "", "type": "none" },
    },
    [sections.FINANCING_TYPE]: {
      "row": { "type": "body", "value": "concession" },
      "left": { "value": isNew ? "" : saleFinancingConcessions.financingType, "type": financingTypeCellType, "options": getOptionsFromDisplayValue(gridData.settings.financingTypeChoices), required: financingTypeRequired },
      "right": { "value": "", "type": "none" },
    },
    [sections.CONCESSION_AMOUNT]: {
      "row": { "type": "body", "value": "concession" },
      "left": { "value": isNew ? "" : saleFinancingConcessions.concessionAmount, "type": concessionAmountCellType, numOnly: true, allowDecimal: false, allowNeg: false, required: concessionAmountRequired },
      "right": { "value": "", "type": "none" },
    },
    [sections.CONCESSION_IF_OTHER]: {
      "row": { "type": "body", "value": "concession" },
      "left": { "value": isNew ? "" : saleFinancingConcessions.concessionOtherAmount, "type": concessionIfOtherAmountCellType },
      "right": { "value": "", "type": "none" },
    },
    [sections.DATE_OF_SALE_TIME]: {
      "row": { "type": "head", "value": "dateOfSaleTime" },
      "left": { "value": isNew ? "" : dateOfSaleTime.summary, "type": "display" },
      "right": { "value": isNew ? "" : dateOfSaleTime.summaryAdjustmentAmount, "type": dateOfSaleCellType },
    },
    [sections.STATUS_TYPE]: {
      "row": { "type": "body", "value": "dateOfSaleTime" },
      "left": { "value": isNew ? "" : dateOfSaleTime.statusType, "type": statusTypeCellType, "options": getOptionsFromDisplayValue(gridData.settings.statusTypeChoices), required: statusTypeRequired },
      "right": { "value": "", "type": "none" },
    },
    [sections.SALE_DATE_1004P]: {
      "row": { "type": "body", "value": "dateOfSaleTime" },
      "left": { "value": isNew ? "" : dateOfSaleTime.saleDate, "type": saleDateCellType, required: saleDateRequired },
      "right": { "value": isNew ? "" : dateOfSaleTime.saleDateAdjustmentAmount, "type": saleDateAdjustmentCellType },
    },
    [sections.CONTRACT_DATE]: {
      "row": { "type": "body", "value": "dateOfSaleTime" },
      "left": { "value": isNew ? "" : dateOfSaleTime.contractDate, "type": saleDateCellType, required: contractDateRequired },
      "right": { "value": isNew ? "" : dateOfSaleTime.contractDateAdjustmentAmount, "type": saleDateAdjustmentCellType },
    },
    [sections.SALE_FNMA]: {
      "row": { "type": "head", "value": "sale2" },
      "left": { "value": isNew ? "" : saleFinancingConcessions.saleType, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.saleTypeChoices), required: true },
      "right": { "value": isNew ? "" : saleFinancingConcessions.summarySaleAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.SALE_DATE_FNMA]: {
      "row": { "type": "head", "value": "saleDate2" },
      "left": { "value": isNew ? "" : dateOfSaleTime.saleDate, "type": "date", required: saleDateRequired },
      "right": { "value": isNew ? "" : dateOfSaleTime.saleDateAdjustmentAmount, "type": "input" },
    },
    [sections.SALE_DATE_BBT]: {
      "row": { "type": "head", "value": "saleDate-bbt" },
      "left": { "value": isNew ? "" : dateOfSaleTime.saleDate, "type": "date", required: saleDateRequired },
      "right": { "value": isNew ? "" : dateOfSaleTime.summaryAdjustmentDesc, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.adjustmentTypeChoices), required: saleDateBBTAdjustmentRequired },
    },
    [sections.PROPERTY_TYPE]: {
      "row": { "type": "head", "value": "propertyType" },
      "left": { "value": isNew ? "" : propertyType.propertyType, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.propertyTypeChoices) },
      "right": { "value": isNew ? "" : propertyType.propertyTypeAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.NUM_OF_UNITS]: {
      "row": { "type": "head", "value": "numOfUnits" },
      "left": { "value": isNew ? "" : numOfUnits.numOfUnits, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false },
      "right": { "value": isNew ? "" : numOfUnits.numOfUnitsAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.YEAR_BUILT]: {
      "row": { "type": "head", "value": "yearBuilt" },
      "left": { "value": isNew ? "" : yearBuilt.yearBuilt, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false },
      "right": { "value": isNew ? "" : actualAge.summaryAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.LOCATION]: {
      "row": { "type": "head", "value": "location" },
      "left": { "value": isNew ? "" : location.summary, "type": "display" },
      "right": settings.compGridFormCode === CompGridFormCodes.BBT_COMPARABLES_GRID_MUELLER_ENTERPRISE
        ? { "value": isNew ? "" : location.summaryAdjustmentDesc, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.adjustmentTypeChoices), required: true }
        : { "value": isNew ? "" : location.summaryAdjustmentAmount, "type": "display", required: adjustmentRequired },
    },

    [sections.LOCATION_RATING]: {
      "row": { "type": "body", "value": "location" },
      "left": { "value": isNew ? "" : location.locationRating, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.locationRatingChoices), required: true },
      "right": settings.compGridFormCode === CompGridFormCodes.BBT_COMPARABLES_GRID_MUELLER_ENTERPRISE
        ? { "value": "", "type": "none" }
        : { "value": isNew ? "" : location.locationRatingAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.LOCATION_TYPE]: {
      "row": { "type": "body", "value": "location" },
      "left": { "value": isNew ? "" : location.locationType, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.locationTypeChoices), required: true },
      "right": settings.compGridFormCode === CompGridFormCodes.BBT_COMPARABLES_GRID_MUELLER_ENTERPRISE
        ? { "value": "", "type": "none" }
        : { "value": isNew ? "" : location.locationTypeAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.LOCATION_TYPE_1_OTHER]: {
      "row": { "type": "body", "value": "location" },
      "left": { "value": isNew ? "" : location.locationType1Other, "type": locationType1OtherCellType, required: locationType1OtherRequired },
      "right": { "value": isNew ? "" : location.locationType1OtherAdjustmentAmount, "type": locationType1OtherAdjustmentCellType, required: adjustmentRequired },
    },
    [sections.LOCATION_TYPE_2]: {
      "row": { "type": "body", "value": "location" },
      "left": { "value": isNew ? "" : location.locationType2, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.locationTypeChoices) },
      "right": settings.compGridFormCode === CompGridFormCodes.BBT_COMPARABLES_GRID_MUELLER_ENTERPRISE
        ? { "value": "", "type": "none" }
        : { "value": isNew ? "" : location.locationType2AdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.LOCATION_TYPE_2_OTHER]: {
      "row": { "type": "body", "value": "location" },
      "left": { "value": isNew ? "" : location.locationType2Other, "type": locationType2OtherCellType, required: locationType2OtherRequired },
      "right": settings.compGridFormCode === CompGridFormCodes.BBT_COMPARABLES_GRID_MUELLER_ENTERPRISE
        ? { "value": "", "type": "none" }
        : { "value": isNew ? "" : location.locationType2OtherAdjustmentAmount, "type": locationType2OtherAdjustmentCellType, required: adjustmentRequired },
    },
    [sections.LEASEHOLD_FEE_SIMPLE]: {
      "row": { "type": "head", "value": "leasehold-feesimple" },
      "left": { "value": isNew ? "" : leasholdFeeSimple.leaseholdFeeSimpleType, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.leaseholdFeeSimpleTypeChoices), required: true },
      "right": { "value": isNew ? "" : leasholdFeeSimple.leaseholdFeeSimpleTypeAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.SITE]: {
      "row": { "type": "head", "value": "site" },
      "left": { "value": isNew ? "" : site.summary, "type": "display", required: true },
      "right": { "value": isNew ? "" : site.summaryAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.SITE_BBT]: {
      "row": { "type": "head", "value": "site" },
      "left": { "value": isNew ? "" : site.summary, "type": "display", required: true },
      "right": { "value": isNew ? "" : site.summaryAdjustmentDesc, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.adjustmentTypeChoices), required: true },
    },
    [sections.SQUARE_FEET]: {
      "row": { "type": "body", "value": "site" },
      "left": { "value": isNew ? "" : site.landAreaSquareFeet, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false },
      "right": { "value": "", "type": "none" },
    },
    [sections.ACRES]: {
      "row": { "type": "body", "value": "site" },
      "left": { "value": isNew ? "" : site.landAreaAcres, "type": "input", numOnly: true, allowDecimal: true, allowNeg: false },
      "right": { "value": "", "type": "none" },
    },
    [sections.ADJUSTMENTS_SITE]: {
      "row": { "type": "body", "value": "site", "adjustment": true },
      "left": { "value": "", "type": "display" },
      "right": { "value": isNew ? "" : "Apply", "type": "display" },
    },
    [sections.VIEW]: {
      "row": { "type": "head", "value": "view" },
      "left": { "value": isNew ? "" : view.summary, "type": "display" },
      "right": { "value": isNew ? "" : view.summaryAdjustmentAmount, "type": "display", required: adjustmentRequired },
    },
    [sections.VIEW_RATING]: {
      "row": { "type": "body", "value": "view" },
      "left": { "value": isNew ? "" : view.viewRating, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.viewRatingChoices), required: true },
      "right": { "value": isNew ? "" : view.viewRatingAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.VIEW_TYPE]: {
      "row": { "type": "body", "value": "view" },
      "left": { "value": isNew ? "" : view.viewType, "type": "dropdown", "options": [...getOptionsFromDisplayValue(gridData.settings.viewTypeChoices), "Other"], required: true },
      "right": { "value": isNew ? "" : view.viewTypeAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.VIEW_TYPE_2]: {
      "row": { "type": "body", "value": "view" },
      "left": { "value": isNew ? "" : view.viewType2, "type": "dropdown", "options": [...getOptionsFromDisplayValue(gridData.settings.viewTypeChoices), "Other"] },
      "right": { "value": "", "type": "none" },
    },
    [sections.DESIGN_STYLE]: {
      "row": { "type": "head", "value": "design" },
      "left": { "value": isNew ? "" : design.summary, "type": "display", required: true },
      "right": { "value": isNew ? "" : design.summaryAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.ATT_DET]: {
      "row": { "type": "body", "value": "design" },
      "left": { "value": isNew ? "" : design.attachedDetached, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.attachedDetachedChoices), required: true },
      "right": { "value": "", "type": "display" },
    },
    [sections.STORIES]: {
      "row": { "type": "body", "value": "design" },
      "left": { "value": isNew ? "" : design.stories, "type": "input", numOnly: true, allowDecimal: true, allowNeg: false, required: true },
      "right": { "value": "", "type": "display" },
    },
    [sections.DESIGN]: {
      "row": { "type": "body", "value": "design" },
      "left": { "value": isNew ? "" : design.designStyle, "type": "input", required: true },
      "right": { "value": "", "type": "display" },
    },
    [sections.ACTUAL_AGE]: {
      "row": { "type": "head", "value": "age" },
      "left": { "value": isNew ? "" : actualAge.ageYears, "type": "input", numOnly: true, allowNeg: false, allowDecimal: false, required: true },
      "right": { "value": isNew ? "" : actualAge.ageYearsAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.ESTIMATED]: {
      "row": { "type": "head", "value": "age-estimated" },
      "left": { "value": isNew ? "" : boolToDisplayValue(actualAge.ageEstimated), "type": "dropdown", "options": getOptionsFromDisplayValue([{ displayValue: "Yes", storedValue: "yes" }, { displayValue: "No", storedValue: "no" }]), required: true },
      "right": { "value": "", "type": "display" },
    },
    [sections.ADJUSTMENTS_AGE]: {
      "row": { "type": "body", "value": "age", "adjustment": true },
      "left": { "value": "", "type": "display" },
      "right": { "value": isNew ? "" : "Apply", "type": "display" },
    },
    [sections.QUALITY]: {
      "row": { "type": "head", "value": "quality" },
      "left": { "value": isNew ? "" : quality.qualityRating, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.qualityChoices), required: true },
      "right": { "value": isNew ? "" : quality.qualityRatingAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.QUALITY_BBT]: {
      "row": { "type": "head", "value": "quality-bbt" },
      "left": { "value": isNew ? "" : quality.qualityRating, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.qualityChoices), required: true },
      "right": { "value": isNew ? "" : quality.summaryAdjustmentDesc, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.adjustmentTypeChoices), required: true },
    },
    [sections.CONDITION]: {
      "row": { "type": "head", "value": "condition" },
      "left": { "value": isNew ? "" : condition.conditionRating, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.conditionChoices), required: true },
      "right": { "value": isNew ? "" : condition.conditionAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.CONDITION_BBT]: {
      "row": { "type": "head", "value": "condition-bbt" },
      "left": { "value": isNew ? "" : condition.conditionRating, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.conditionChoices), required: true },
      "right": { "value": isNew ? "" : condition.summaryAdjustmentDesc, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.adjustmentTypeChoices), required: true },
    },
    [sections.NUM_OF_FLOORS]: {
      "row": { "type": "head", "value": "numOfFloors" },
      "left": { "value": isNew ? "" : numOfFloors.numOfFloors, "type": "input", numOnly: true, allowNeg: false, allowDecimal: false, required: true },
      "right": { "value": isNew ? "" : numOfFloors.numOfFloorsAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.FLOOR_LOCATION]: {
      "row": { "type": "head", "value": "floorLocation" },
      "left": { "value": isNew ? "" : floorLocation.floorLocation, "type": "input", required: true },
      "right": { "value": isNew ? "" : floorLocation.floorLocationAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.MONTHLY_RENTAL_RATE]: {
      "row": { "type": "head", "value": "monthlyRentalRate" },
      "left": { "value": isNew ? "" : monthlyRentalRate.monthlyRentalRate, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false },
      "right": { "value": isNew ? "" : monthlyRentalRate.monthlyRentalRateAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.ABOVE_GRADE]: {
      "row": { "type": "head", "value": "above-grade" },
      "left": { "value": "", "type": "room-count", "options": ["Total", "Bed", "Bath"] },
      "right": { "value": "", "type": "none" },
    },
    [sections.ABOVE_GRADE_BBT]: {
      "row": { "type": "head", "value": "above-grade-bbt" },
      "left": { "value": "", "type": "room-count", "options": ["Total", "Bed", "Bath"] },
      "right": { "value": "", "type": "none" },
    },
    [sections.ABOVE_GRADE_ROOM_COUNT]: {
      "row": { "type": "head", "value": "above-grade" },
      "left": { "value": "", "type": "room-count", "options": isNew ? ["-", "-", "-.-"] : [noValueDash(aboveGradeRooms.totalRoomCount), noValueDash(aboveGradeRooms.bedroomCount), `${noValueDash(aboveGradeRooms.fullBathroomCount)}.${noValueDash(aboveGradeRooms.halfBathroomCount)}`] },
      "right": { "value": isNew ? "" : aboveGradeRooms.summaryAdjustmentAmount, "type": "input" },
    },
    [sections.ABOVE_GRADE_ROOM_COUNT_BBT]: {
      "row": { "type": "head", "value": "above-grade-bbt" },
      "left": { "value": "", "type": "room-count", "options": isNew ? ["-", "-", "-.-"] : [noValueDash(aboveGradeRooms.totalRoomCount), noValueDash(aboveGradeRooms.bedroomCount), `${noValueDash(aboveGradeRooms.fullBathroomCount)}.${noValueDash(aboveGradeRooms.halfBathroomCount)}`] },
      "right": { "value": isNew ? "" : aboveGradeRooms.summaryAdjustmentDesc, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.adjustmentTypeChoices), required: true },
    },
    [sections.TOTAL]: {
      "row": { "type": "body", "value": "above-grade" },
      "left": { "value": isNew ? "" : aboveGradeRooms.totalRoomCount, "type": "input", required: true },
      "right": { "value": isNew ? "" : aboveGradeRooms.totalRoomCountAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.TOTAL_BBT]: {
      "row": { "type": "body", "value": "above-grade-bbt" },
      "left": { "value": isNew ? "" : aboveGradeRooms.totalRoomCount, "type": "input", required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.BEDROOMS]: {
      "row": { "type": "body", "value": "above-grade" },
      "left": { "value": isNew ? "" : aboveGradeRooms.bedroomCount, "type": "input", required: true },
      "right": { "value": isNew ? "" : aboveGradeRooms.bedroomCountAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.BEDROOMS_BBT]: {
      "row": { "type": "body", "value": "above-grade-bbt" },
      "left": { "value": isNew ? "" : aboveGradeRooms.bedroomCount, "type": "input", required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.BATHROOMS]: {
      "row": { "type": "body", "value": "above-grade" },
      "left": { "value": isNew ? "" : aboveGradeRooms.fullBathroomCount, "type": "input", required: true },
      "right": { "value": isNew ? "" : aboveGradeRooms.fullBathroomCountAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.BATHROOMS_BBT]: {
      "row": { "type": "body", "value": "above-grade-bbt" },
      "left": { "value": isNew ? "" : aboveGradeRooms.fullBathroomCount, "type": "input", required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.HALF_BATHROOMS]: {
      "row": { "type": "body", "value": "above-grade" },
      "left": { "value": isNew ? "" : aboveGradeRooms.halfBathroomCount, "type": "input", required: true },
      "right": { "value": isNew ? "" : aboveGradeRooms.halfBathroomCountAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.HALF_BATHROOMS_BBT]: {
      "row": { "type": "body", "value": "above-grade-bbt" },
      "left": { "value": isNew ? "" : aboveGradeRooms.halfBathroomCount, "type": "input", required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.ADJUSTMENTS_ROOM_COUNT]: {
      "row": { "type": "body", "value": "above-grade", "adjustment": true },
      "left": { "value": "", "type": "display" },
      "right": { "value": isNew ? "" : "Apply", "type": "display" },
    },
    [sections.GLA]: {
      "row": { "type": "head", "value": "gla" },
      "left": { "value": isNew ? "" : grossLivingArea.grossLivingArea, "type": "input", required: true },
      "right": { "value": isNew ? "" : grossLivingArea.grossLivingAreaAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.GLA_BBT]: {
      "row": { "type": "head", "value": "gla-bbt" },
      "left": { "value": isNew ? "" : grossLivingArea.grossLivingArea, "type": "input", required: true },
      "right": { "value": isNew ? "" : grossLivingArea.summaryAdjustmentDesc, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.adjustmentTypeChoices), required: true },
    },
    [sections.ADJUSTMENTS_GLA]: {
      "row": { "type": "body", "value": "gla", "adjustment": true },
      "left": { "value": "", "type": "display" },
      "right": { "value": isNew ? "" : "Apply", "type": "display" },
    },
    [sections.BASEMENT_FINISHED]: {
      "row": { "type": "head", "value": "basement-finished" },
      "left": { "value": isNew ? "" : belowGrade.summary, "type": "display" },
      "right": { "value": isNew ? "" : belowGrade.summaryAdjustmentAmount, "type": "display" },
    },
    [sections.BASEMENT_FINISHED_BBT]: {
      "row": { "type": "head", "value": "basement-finished-bbt" },
      "left": { "value": isNew ? "" : belowGrade.summary, "type": "display" },
      "right": { "value": isNew ? "" : belowGrade.summaryAdjustmentDesc, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.adjustmentTypeChoices), required: true },
    },
    [sections.BELOW_GRADE_TOT_SF]: {
      "row": { "type": "body", "value": "basement-finished" },
      "left": { "value": isNew ? "" : belowGrade.totalSquareFeet, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
      "right": { "value": isNew ? "" : belowGrade.totalSquareFeetAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.BELOW_GRADE_TOT_SF_BBT]: {
      "row": { "type": "body", "value": "basement-finished-bbt" },
      "left": { "value": isNew ? "" : belowGrade.totalSquareFeet, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.BELOW_GRADE_FIN_SF]: {
      "row": { "type": "body", "value": "basement-finished" },
      "left": { "value": isNew ? "" : belowGrade.finishedSquareFeet, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: belowGradeFinSFRequired },
      "right": { "value": isNew ? "" : belowGrade.finishedSquareFeetAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.BELOW_GRADE_FIN_SF_BBT]: {
      "row": { "type": "body", "value": "basement-finished-bbt" },
      "left": { "value": isNew ? "" : belowGrade.finishedSquareFeet, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: belowGradeFinSFRequired },
      "right": { "value": "", "type": "none" },
    },
    [sections.BASEMENT_EXIT_TYPE]: {
      "row": { "type": "body", "value": "basement-finished" },
      "left": { "value": isNew ? "" : belowGrade.basementExitType, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.basementExitTypeChoices), required: basementExitTypeRequired },
      "right": { "value": isNew ? "" : belowGrade.basementExitTypeAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.BASEMENT_EXIT_TYPE_BBT]: {
      "row": { "type": "body", "value": "basement-finished-bbt" },
      "left": { "value": isNew ? "" : belowGrade.basementExitType, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.basementExitTypeChoices), required: basementExitTypeRequired },
      "right": { "value": "", "type": "none" },
    },
    [sections.BELOW_GRADE_ROOM_COUNT_FNMA]: {
      "row": { "type": "head", "value": "belowGradeRoomCount" },
      "left": { "value": isNew ? "" : belowGradeRoomCount.belowGradeRoomCount, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
      "right": { "value": isNew ? "" : belowGradeRooms.summaryAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.HEATING_FNMA]: {
      "row": { "type": "head", "value": "heating2" },
      "left": { "value": isNew ? "" : heatingCooling.heatingType, "type": "input", required: true },
      "right": { "value": isNew ? "" : heatingCooling.heatingTypeAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.COOLING_FNMA]: {
      "row": { "type": "head", "value": "cooling2" },
      "left": { "value": isNew ? "" : heatingCooling.coolingType, "type": "input", required: true },
      "right": { "value": isNew ? "" : heatingCooling.coolingTypeAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.BELOW_GRADE]: {
      "row": { "type": "head", "value": "below-grade-rooms" },
      "left": { "value": isNew ? "" : belowGradeRooms.summary, "type": "room-count", "options": ["Rec", "Bed", "Bath", "Othr"] },
      "right": { "value": isNew ? "" : belowGradeRooms.summaryAdjustmentAmount, "type": "display" }
    },
    [sections.BELOW_GRADE_ROOM_COUNT]: {
      "row": { "type": "head", "value": "below-grade-rooms" },
      "left": { "value": "", "type": "room-count", "options": isNew ? ["-", "-", "-.-", "-"] : [noValueDash(belowGradeRooms.recRoomCount), noValueDash(belowGradeRooms.bedroomCount), `${noValueDash(belowGradeRooms.fullBathroomCount)}.${noValueDash(belowGradeRooms.halfBathroomCount)}`, noValueDash(belowGradeRooms.otherRoomCount)] },
      "right": { "value": "", "type": "display" },
    },
    [sections.REC]: {
      "row": { "type": "body", "value": "below-grade-rooms" },
      "left": { "value": isNew ? "" : belowGradeRooms.recRoomCount, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
      "right": { "value": isNew ? "" : belowGradeRooms.recRoomCountAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.BED]: {
      "row": { "type": "body", "value": "below-grade-rooms" },
      "left": { "value": isNew ? "" : belowGradeRooms.bedroomCount, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
      "right": { "value": isNew ? "" : belowGradeRooms.bedroomCountAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.FULL_BATH]: {
      "row": { "type": "body", "value": "below-grade-rooms" },
      "left": { "value": isNew ? "" : belowGradeRooms.fullBathroomCount, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
      "right": { "value": isNew ? "" : belowGradeRooms.fullBathroomCountAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.HALF_BATH]: {
      "row": { "type": "body", "value": "below-grade-rooms" },
      "left": { "value": isNew ? "" : belowGradeRooms.halfBathroomCount, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
      "right": { "value": isNew ? "" : belowGradeRooms.halfBathroomCountAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.OTHER]: {
      "row": { "type": "body", "value": "below-grade-rooms" },
      "left": { "value": isNew ? "" : belowGradeRooms.otherRoomCount, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: true },
      "right": { "value": isNew ? "" : belowGradeRooms.otherRoomCountAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.HEATING_COOLING]: {
      "row": { "type": "head", "value": "heating-cooling" },
      "left": { "value": isNew ? "" : heatingCooling.summary, "type": "display" },
      "right": { "value": isNew ? "" : heatingCooling.summaryAdjustmentAmount, "type": "display" },
    },
    [sections.HEATING_1004P]: {
      "row": { "type": "body", "value": "heating-cooling" },
      "left": { "value": isNew ? "" : heatingCooling.heatingType, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.heatingTypeChoices), required: true },
      "right": { "value": isNew ? "" : heatingCooling.heatingTypeAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.COOLING_1004P]: {
      "row": { "type": "body", "value": "heating-cooling" },
      "left": { "value": isNew ? "" : heatingCooling.coolingType, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.coolingTypeChoices), required: true },
      "right": { "value": isNew ? "" : heatingCooling.coolingTypeAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.GARAGE_CARPORT]: {
      "row": { "type": "head", "value": "garage-carport" },
      "left": { "value": isNew ? "" : garageCarport.summary, "type": "display", required: true },
      "right": { "value": isNew ? "" : garageCarport.summaryAdjustmentAmount, "type": "display", required: adjustmentRequired },
    },
    [sections.GARAGE_CARPORT_BBT]: {
      "row": { "type": "head", "value": "garage-carport-bbt" },
      "left": { "value": isNew ? "" : garageCarport.summary, "type": "display", required: true },
      "right": { "value": isNew ? "" : garageCarport.summaryAdjustmentDesc, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.adjustmentTypeChoices), required: true },
    },
    [sections.GARAGE_CARPORT_MVALUE]: {
      "row": { "type": "head", "value": "garage-carport-mvalue" },
      "left": { "value": isNew ? "" : garageCarport.summary, "type": "display", required: true },
      "right": { "value": isNew ? "" : garageCarport.summaryAdjustmentAmount, "type": "display", required: adjustmentRequired },
    },
    [sections.DRIVEWAY]: {
      "row": { "type": "body", "value": "garage-carport" },
      "left": { "value": isNew ? "" : garageCarport.drivewayType, "type": "dropdown", "options": getOptionsFromDisplayValue([{ displayValue: "Yes", storedValue: "yes" }, { displayValue: "No", storedValue: "no" }]), required: false },
      "right": { "value": isNew ? "" : garageCarport.drivewayTypeAdjustmentAmount, "type": "input", required: false },
    },
    [sections.DRIVEWAY_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt" },
      "left": { "value": isNew ? "" : garageCarport.drivewayType, "type": "dropdown", "options": getOptionsFromDisplayValue([{ displayValue: "Yes", storedValue: "yes" }, { displayValue: "No", storedValue: "no" }]), required: false },
      "right": { "value": "", "type": "none" },
    },
    [sections.DRIVEWAY_ENABLED]: {
      "row": { "type": "body", "value": "garage-carport-mvalue" },
      "left": { "value": isNew ? "" : garageCarport.drivewayType, "type": "dropdown", "options": getOptionsFromDisplayValue([{ displayValue: "Yes", storedValue: "yes" }, { displayValue: "No", storedValue: "no" }]), required: false },
      "right": { "value": isNew ? "" : garageCarport.drivewayTypeAdjustmentAmount, "type": "input", required: false },
    },
    [sections.NUM_OF_CARS]: {
      "row": { "type": "body", "value": "garage-carport" },
      "left": { "value": isNew ? "" : garageCarport.drivewayCarCapacity, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: numOfCarsRequired },
      "right": { "value": isNew ? "" : garageCarport.drivewayCarCapacityAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.NUM_OF_CARS_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt" },
      "left": { "value": isNew ? "" : garageCarport.drivewayCarCapacity, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: numOfCarsRequired },
      "right": { "value": "", "type": "none" },
    },
    [sections.NUM_OF_CARS_MVALUE]: {
      "row": { "type": "body", "value": "garage-carport-mvalue" },
      "left": { "value": isNew ? "" : garageCarport.drivewayCarCapacity, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: numOfCarsRequired },
      "right": { "value": isNew ? "" : garageCarport.drivewayCarCapacityAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.CAR_STORAGE_1]: {
      "row": { "type": "body", "value": "garage-carport" },
      "left": { "value": isNew ? "" : garageCarport.carStorageType1, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.carStorageChoices), required: carStorage1Required },
      "right": { "value": isNew ? "" : garageCarport.carStorageTypeAdjustmentAmount1, "type": "input", required: adjustmentRequired },
    },
    [sections.CAR_STORAGE_1_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt" },
      "left": { "value": isNew ? "" : garageCarport.carStorageType1, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.carStorageChoices), required: carStorage1Required },
      "right": { "value": "", "type": "none" },
    },
    [sections.CAR_STORAGE_1_MVALUE]: {
      "row": { "type": "body", "value": "garage-carport-mvalue" },
      "left": { "value": isNew ? "" : garageCarport.carStorageType1, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.carStorageChoices), required: carStorage1Required },
      "right": { "value": isNew ? "" : garageCarport.carStorageTypeAdjustmentAmount1, "type": "input", required: adjustmentRequired },
    },
    [sections.ATTACHMENT_TYPE_1]: {
      "row": { "type": "body", "value": "garage-carport" },
      "left": { "value": isNew ? "" : garageCarport.carStorageAttachmentType1, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.carStorageAttachmentTypeChoices), required: attachmentType1Required },
      "right": { "value": isNew ? "" : garageCarport.carStorageAttachmentTypeAdjustmentAmount1, "type": "input", required: adjustmentRequired },
    },
    [sections.ATTACHMENT_TYPE_1_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt" },
      "left": { "value": isNew ? "" : garageCarport.carStorageAttachmentType1, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.carStorageAttachmentTypeChoices), required: attachmentType1Required },
      "right": { "value": "", "type": "none" },
    },
    [sections.ATTACHMENT_TYPE_1_MVALUE]: {
      "row": { "type": "body", "value": "garage-carport-mvalue" },
      "left": { "value": isNew ? "" : garageCarport.carStorageAttachmentType1, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.carStorageAttachmentTypeChoices), required: attachmentType1Required },
      "right": { "value": isNew ? "" : garageCarport.carStorageAttachmentTypeAdjustmentAmount1, "type": "input", required: adjustmentRequired },
    },
    [sections.NUM_OF_CARS_1]: {
      "row": { "type": "body", "value": "garage-carport" },
      "left": { "value": isNew ? "" : garageCarport.carStorageCarCapacity1, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: numOfCars1Required },
      "right": { "value": isNew ? "" : garageCarport.carStorageCarCapacityAdjustmentAmount1, "type": "input", required: adjustmentRequired },
    },
    [sections.NUM_OF_CARS_1_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt" },
      "left": { "value": isNew ? "" : garageCarport.carStorageCarCapacity1, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: numOfCars1Required },
      "right": { "value": "", "type": "none" },
    },
    [sections.NUM_OF_CARS_1_MVALUE]: {
      "row": { "type": "body", "value": "garage-carport-mvalue" },
      "left": { "value": isNew ? "" : garageCarport.carStorageCarCapacity1, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false, required: numOfCars1Required },
      "right": { "value": isNew ? "" : garageCarport.carStorageCarCapacityAdjustmentAmount1, "type": "input", required: adjustmentRequired },
    },
    [sections.CAR_STORAGE_2]: {
      "row": { "type": "body", "value": "garage-carport" },
      "left": { "value": isNew ? "" : garageCarport.carStorageType2, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.carStorageChoices) },
      "right": { "value": isNew ? "" : garageCarport.carStorageTypeAdjustmentAmount2, "type": "input", required: adjustmentRequired },
    },
    [sections.CAR_STORAGE_2_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt" },
      "left": { "value": isNew ? "" : garageCarport.carStorageType2, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.carStorageChoices) },
      "right": { "value": "", "type": "none" },
    },
    [sections.CAR_STORAGE_2_MVALUE]: {
      "row": { "type": "body", "value": "garage-carport-mvalue" },
      "left": { "value": isNew ? "" : garageCarport.carStorageType2, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.carStorageChoices) },
      "right": { "value": isNew ? "" : garageCarport.carStorageTypeAdjustmentAmount2, "type": "input", required: adjustmentRequired },
    },
    [sections.ATTACHMENT_TYPE_2]: {
      "row": { "type": "body", "value": "garage-carport" },
      "left": { "value": isNew ? "" : garageCarport.carStorageAttachmentType2, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.carStorageAttachmentTypeChoices) },
      "right": { "value": isNew ? "" : garageCarport.carStorageAttachmentTypeAdjustmentAmount2, "type": "input", required: adjustmentRequired },
    },
    [sections.ATTACHMENT_TYPE_2_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt" },
      "left": { "value": isNew ? "" : garageCarport.carStorageAttachmentType2, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.carStorageAttachmentTypeChoices) },
      "right": { "value": "", "type": "none" },
    },
    [sections.ATTACHMENT_TYPE_2_MVALUE]: {
      "row": { "type": "body", "value": "garage-carport-mvalue" },
      "left": { "value": isNew ? "" : garageCarport.carStorageAttachmentType2, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.carStorageAttachmentTypeChoices) },
      "right": { "value": isNew ? "" : garageCarport.carStorageAttachmentTypeAdjustmentAmount2, "type": "input", required: adjustmentRequired },
    },
    [sections.NUM_OF_CARS_2]: {
      "row": { "type": "body", "value": "garage-carport" },
      "left": { "value": isNew ? "" : garageCarport.carStorageCarCapacity2, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false },
      "right": { "value": isNew ? "" : garageCarport.carStorageCarCapacityAdjustmentAmount2, "type": "input", required: adjustmentRequired },
    },
    [sections.NUM_OF_CARS_2_BBT]: {
      "row": { "type": "body", "value": "garage-carport-bbt" },
      "left": { "value": isNew ? "" : garageCarport.carStorageCarCapacity2, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false },
      "right": { "value": "", "type": "none" },
    },
    [sections.NUM_OF_CARS_2_MVALUE]: {
      "row": { "type": "body", "value": "garage-carport-mvalue" },
      "left": { "value": isNew ? "" : garageCarport.carStorageCarCapacity2, "type": "input", numOnly: true, allowDecimal: false, allowNeg: false },
      "right": { "value": isNew ? "" : garageCarport.carStorageCarCapacityAdjustmentAmount2, "type": "input", required: adjustmentRequired },
    },
    [sections.ENERGY_EFFICIENT_ITEMS]: {
      "row": { "type": "head", "value": "energy-efficient-items" },
      "left": { "value": isNew ? "" : energyEfficientItems.energyEfficientItems, "type": "input", required: true },
      "right": { "value": isNew ? "" : energyEfficientItems.energyEfficientItemsAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.FUNCTIONAL_UTILITY]: {
      "row": { "type": "head", "value": "functional-utility" },
      "left": { "value": isNew ? "" : functionalUtility.functionalUtility, "type": "input", required: true },
      "right": { "value": isNew ? "" : functionalUtility.functionalUtilityAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.PORCH_PATIO_DECK]: {
      "row": { "type": "head", "value": "porch-patio-deck" },
      "left": { "value": isNew ? "" : porchPatioDeck.summary, "type": "display", required: true },
      "right": { "value": isNew ? "" : porchPatioDeck.porchPatioDeckTypeAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.PORCH]: {
      "row": { "type": "body", "value": "porch-patio-deck" },
      "left": { "value": isNew ? "" : porchPatioDeck.porchType, "type": "input", required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.PATIO_DECK]: {
      "row": { "type": "body", "value": "porch-patio-deck" },
      "left": { "value": isNew ? "" : porchPatioDeck.patioDeckType, "type": "input", required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.POOL]: {
      "row": { "type": "head", "value": "pool" },
      "left": { "value": isNew ? "" : pool.pool, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.poolTypeChoices) },
      "right": { "value": isNew ? "" : pool.poolAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.OTHER_NAME_1]: {
      "row": { "type": "head", "value": "other-name-1" },
      "left": { "value": "", "type": "none" },
      "right": { "value": "", "type": "none" },
    },
    [sections.OTHER_1_DESC]: {
      "row": { "type": "head", "value": "other-1-desc" },
      "left": { "value": isNew ? "" : other.otherDesc, "type": "input" },
      "right": { "value": isNew ? "" : other.otherTypeAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.OTHER_NAME_2]: {
      "row": { "type": "head", "value": "other-name-2" },
      "left": { "value": "", "type": "none" },
      "right": { "value": "", "type": "none" },
    },
    [sections.OTHER_2_DESC]: {
      "row": { "type": "head", "value": "other-2-desc" },
      "left": { "value": isNew ? "" : other.other2Desc, "type": "input" },
      "right": { "value": isNew ? "" : other.other2TypeAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.OTHER_NAME_3]: {
      "row": { "type": "head", "value": "other-name-3" },
      "left": { "value": "", "type": "none" },
      "right": { "value": "", "type": "none" },
    },
    [sections.OTHER_3_DESC]: {
      "row": { "type": "head", "value": "other-3-desc" },
      "left": { "value": isNew ? "" : other.other3Desc, "type": "input" },
      "right": { "value": isNew ? "" : other.other3TypeAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.NET_ADJ]: {
      "row": { "type": "head", "value": "net-adj" },
      "left": { "value": "", "type": "none" },
      "right": { "value": isNew ? "" : netAdjustmentsAmount, "type": "display" },
    },
    [sections.ADJ_NET_PRICE]: {
      "row": { "type": "head", "value": "adj-net-price" },
      "left": { "value": isNew ? "" : netAdjustmentsPercentage, "type": "display" },
      "right": { "value": isNew ? "" : grossAdjustmentsAmount, "type": "display" }, //grossAdjustmentsAmount coz thats what backend calls it
    },
    [sections.ADJ_GROSS_PRICE]: {
      "row": { "type": "head", "value": "adj-gross-price" },
      "left": { "value": isNew ? "" : grossAdjustmentsPercentage, "type": "display" },
      "right": { "value": "", "type": "none" },
    },
    [sections.ACTUAL_AGE_MVALUE]: {
      "row": { "type": "head", "value": "actual-age-mvalue" },
      "left": { "value": isNew ? "" : item.actualAge.ageYears, "type": "input", required: true },
      "right": { "value": isNew ? "" : item.actualAge.summaryAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.ACTUAL_AGE_BBT]: {
      "row": { "type": "head", "value": "actual-age-bbt" },
      "left": { "value": isNew ? "" : item.actualAge.ageYears, "type": "input", required: true },
      "right": { "value": isNew ? "" : item.actualAge.summaryAdjustmentDesc, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.adjustmentTypeChoices), required: true },
    },
    [sections.OTHER_MVALUE]: {
      "row": { "type": "head", "value": "other-mvalue" },
      "left": { "value": isNew ? "" : item.other.otherType, "type": "input" },
      "right": { "value": isNew ? "" : item.other.otherTypeAdjustmentAmount, "type": "input", required: adjustmentRequired },
    },
    [sections.OTHER_BBT]: {
      "row": { "type": "head", "value": "other-bbt" },
      "left": { "value": isNew ? "" : item.other.otherType, "type": "input" },
      "right": { "value": isNew ? "" : item.other.summaryAdjustmentDesc, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.adjustmentTypeChoices), required: otherBBTAdjustmentRequired },
    },
    [sections.COMPARISON_TO_SUBJECT]: {
      "row": { "type": "head", "value": "comparison-to-subject" },
      "left": { "value": isNew ? "" : item.comparisonToSubject, "type": "dropdown", "options": getOptionsFromDisplayValue(gridData.settings.adjustmentTypeChoices), required: true },
      "right": { "value": "", "type": "none" },
    },
    [sections.COMMENTS]: {
      "row": { "type": "head", "value": "comments" },
      "left": { "value": isNew ? "" : item.adjustmentComments, "type": "textarea" },
      "right": { "value": "", "type": "none" },
    },
  };
  const filtered = getFormSections(gridData.settings.compGridFormCode)
    .reduce((acc, key) => {
      let sec = allComparableSections[key];
      if (readOnly) {
        // dont add adjustment calc section
        if (sec && sec.row && sec.row.adjustment) {
          return acc;
        }
        sec = convertTypeToReadOnly(sec);
      }
      acc[key] = sec;
      return acc;
    }, {});
  return filtered;
};

// Determine cell type
// Functions to determine cell type will be called on each render
// 3 arguments will be passed in this same order: table, tableIndex, subTableKey, dir
const salePriceCellType = (table, tableIndex) =>
  table[tableIndex][sections.COMPARABLE_TYPE]["left"].value === "list" ? "none" : "input";
const dateOfSaleCellType = (table, tableIndex) =>
  table[tableIndex][sections.COMPARABLE_TYPE]["left"].value === "list" ? "none" : "display";
const saleDateCellType = (table, tableIndex) =>
  table[tableIndex][sections.COMPARABLE_TYPE]["left"].value === "list" ? "none" : "date";
const statusTypeCellType = (table, tableIndex) =>
  table[tableIndex][sections.COMPARABLE_TYPE]["left"].value === "list" ? "none" : "dropdown";
const saleDateAdjustmentCellType = salePriceCellType;
const locationType1OtherCellType = (table, tableIndex, subTableKey, dir) =>
  table[tableIndex][sections.LOCATION_TYPE][dir].value === "Other" ? "input" : "display";
const locationType2OtherCellType = (table, tableIndex, subTableKey, dir) =>
  table[tableIndex][sections.LOCATION_TYPE_2][dir].value === "Other" ? "input" : "display";
const locationType1OtherAdjustmentCellType = (table, tableIndex) =>
  table[tableIndex][sections.LOCATION_TYPE]["left"].value === "Other" ? "input" : "display";
const locationType2OtherAdjustmentCellType = (table, tableIndex) =>
  table[tableIndex][sections.LOCATION_TYPE_2]["left"].value === "Other" ? "input" : "display";

const financingConcessionsCellType = dateOfSaleCellType;
const saleCellType = statusTypeCellType;
const financingTypeCellType = statusTypeCellType;
const concessionAmountCellType = salePriceCellType;
const concessionIfOtherAmountCellType = salePriceCellType;
const saleOrAdjustmentCellType = salePriceCellType;
